"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var createWorkerResource = function createWorkerResource(interval) {
  var codeBlock = "var time = 0;\n    var intervalId ;\n    onmessage = (event) => {\n    //   if (!event.data.interval) throw new Error(\"No Interval found !!!\");\n    if(event.data.type === 'Start' || event.data.type === 'Stop') {\n        clearInterval(intervalId);\n        time = 0;\n      }\n      if (event.data.type === \"Start\") {\n        time = 0;\n        intervalId = setInterval(() => {\n          time += ".concat(interval, ";\n          postMessage({\n            type: \"Time\",\n            value: time\n          });\n        }, ").concat(interval, ");\n      }\n    };\n    ");
  return codeBlock;
};
var useWorkerInterval = function useWorkerInterval(interval) {
  var generateWorker = (0, _react.useCallback)(function () {
    var blobUrl = createWorkerResource(interval);
    var blob = new Blob([blobUrl], {
      type: 'application/javascript'
    });
    var blobURL = URL.createObjectURL(blob);
    var worker = new Worker(blobURL);
    worker._url = blobURL;
    return worker;
  }, []);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    worker = _useState2[0],
    setWorker = _useState2[1];
  var isRunning = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    setWorker(generateWorker());
    return function () {
      return worker === null || worker === void 0 ? void 0 : worker.terminate();
    };
  }, []);
  var startWorker = function startWorker() {
    if (!isRunning.current) {
      worker === null || worker === void 0 ? void 0 : worker.postMessage({
        type: 'Start'
      });
      isRunning.current = true;
    }
  };
  var stopTimer = function stopTimer() {
    worker === null || worker === void 0 ? void 0 : worker.postMessage({
      type: 'Stop'
    });
    // worker.terminate();
    isRunning.current = false;
  };
  return {
    worker: worker,
    startWorker: startWorker,
    stopTimer: stopTimer,
    isRunning: isRunning
  };
};
var _default = useWorkerInterval;
exports["default"] = _default;